import { useState } from "react";
import { CalendarDays } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { fmtDay } from "@/lib/api";

const toYMD = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const fromYMD = (s) => (s ? new Date(`${s}T12:00:00`) : undefined);

export const EventDatePicker = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid="drop-event-date-button" className="flex h-10 w-full items-center gap-2 rounded-md border border-zinc-800 bg-zinc-900 px-3 text-left text-sm transition-colors hover:border-zinc-600">
          <CalendarDays className="h-4 w-4 text-amber-300" />
          <span className={value ? "" : "text-zinc-500"}>{value ? fmtDay(value) : "Pick the event date"}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-zinc-950 border-zinc-800" align="start" data-testid="drop-event-date-calendar">
        <Calendar mode="single" selected={fromYMD(value)} defaultMonth={fromYMD(value)} onSelect={(d) => { onChange(d ? toYMD(d) : ""); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
};

export const UnitFancallFields = ({ f, setF }) => (
  <div className="rounded-xl border border-amber-500/30 bg-amber-500/5 p-4 space-y-4" data-testid="drop-unit-fancall-fields">
    <div className="text-xs text-amber-200/80">Joiners are asked on the drop page whether they want to opt in for the call. Each claim is 1 raffle entry, up to 4 entries.</div>
    <div className="space-y-1.5">
      <Label>Event Date</Label>
      <EventDatePicker value={f.event_date} onChange={(v) => setF({ ...f, event_date: v })} />
    </div>
    <label className="flex items-center gap-3 cursor-pointer">
      <Checkbox data-testid="drop-passport-only-checkbox" checked={f.passport_only} onCheckedChange={(c) => setF({ ...f, passport_only: !!c })} />
      <span>
        <span className="block text-sm font-medium">Passport Only</span>
        <span className="block text-xs text-zinc-500">Shows a Passport Only notice on the drop page</span>
      </span>
    </label>
  </div>
);
